<template>
  <svg id="download-icon" enable-background="new 0 0 511.999 511.999" :height="height" viewBox="0 0 511.999 511.999" :width="width" xmlns="http://www.w3.org/2000/svg" xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/"><g><path d="m422.651 225.765v248.961c0 20.586-16.688 37.273-37.273 37.273h-306.206c-20.586 0-37.273-16.688-37.273-37.273v-390.003c0-20.591 16.692-37.273 37.273-37.273h165.159z" fill="#bed8fb"/><path d="m126.622 464.55c-20.586 0-37.273-16.688-37.273-37.273v-390.004c-.001-20.591 16.691-37.273 37.273-37.273h165.158c28.395 0 178.32 149.924 178.32 178.316v248.961c0 20.586-16.688 37.273-37.273 37.273z" fill="#ddeafb"/><path d="m470.1 178.319v15.767c0-33.195-26.918-60.113-60.113-60.113h-36.587c-20.581 0-37.273-16.692-37.273-37.273v-36.587c0-33.195-26.918-60.113-60.113-60.113h15.767c28.39 0 55.627 11.28 75.701 31.355l71.264 71.264c20.073 20.074 31.354 47.31 31.354 75.7z" fill="#bed8fb"/><g fill="#0C5689"><path d="m316.833 269.653v-108.975c0-4.701-3.811-8.512-8.512-8.512h-57.194c-4.701 0-8.512 3.811-8.512 8.512v108.975h-24.315c-7.583 0-11.381 9.168-6.019 14.53l54.331 54.331c7.241 7.241 18.982 7.241 26.223 0l54.331-54.331c5.362-5.362 1.564-14.53-6.019-14.53z"/><path d="m346.052 368.421h-132.656c-9.161 0-16.587 7.426-16.587 16.587v.456c0 9.161 7.426 16.587 16.587 16.587h132.656c9.161 0 16.587-7.426 16.587-16.587v-.456c0-9.161-7.426-16.587-16.587-16.587z"/></g></g></svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 512
    },
    height: {
      type: [Number, String],
      default: 512
    },
    iconColor: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style scoped>
svg {
  max-width: 100%;
}
</style>
